import { io } from "socket.io-client";

class SocketIO {
  bd = "";
  socket = "";
  constructor(bd) {
    this.bd = bd;
  }

  criarConexao() {
    this.socket = io(process.env.VUE_APP_SOCKET);
    this.socket.emit("join", this.bd);
  }

  disconectar() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  emitir(rota, data) {
    this.socket.emit(rota, data);
  }
}

export default SocketIO;
